// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__3QvLr","pencil":"IconEdit_pencil__3jVng"};